import { FC } from 'react';
import { ScreensaverInactivityTimeout } from 'components/ScreensaverInactivityTimeout';

export const InactivityPage: FC = () => {
	return <ScreensaverInactivityTimeout />;
};
